'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.getElementsByClassName = getElementsByClassName;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _RenderQuestion = require('./RenderQuestion');

var _RenderQuestion2 = _interopRequireDefault(_RenderQuestion);

var _RenderText = require('./RenderText');

var _RenderText2 = _interopRequireDefault(_RenderText);

var _RenderSummary = require('./RenderSummary');

var _RenderSummary2 = _interopRequireDefault(_RenderSummary);

var _RenderEmail = require('./RenderEmail');

var _RenderEmail2 = _interopRequireDefault(_RenderEmail);

var _RenderForm = require('./RenderForm');

var _RenderForm2 = _interopRequireDefault(_RenderForm);

var _LeadSubmitter = require('./LeadSubmitter');

var _LeadSubmitter2 = _interopRequireDefault(_LeadSubmitter);

var _Tracking = require('./Tracking');

var _Tracking2 = _interopRequireDefault(_Tracking);

var _webfontloader = require('webfontloader');

var _webfontloader2 = _interopRequireDefault(_webfontloader);

var _reactMeasure = require('react-measure');

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _reactCookie = require('react-cookie');

var _immutable = require('immutable');

var _wseQuizData = require('wse-quiz-data');

require('./RenderQuiz_text.css');

require('./RenderQuiz_structure.css');

require('./RenderQuiz_structure-mobile.css');

require('./RenderQuiz_other.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MOBILE_BREAK_PT = 600;

var COMPLETE = 'quiz_complete';

function getElementsByClassName(cl) {
    if (document.getElementsByClassName) {
        return Array.from(document.getElementsByClassName(cl));
    }

    var rtn = [];
    Array.from(document.getElementsByTagName('*')).forEach(function (el) {
        if ((' ' + el.className + ' ').indexOf(' ' + cl + ' ') > -1) {
            rtn.push(el);
        }
    });
    return rtn;
}

var RenderQuiz = function (_React$Component) {
    _inherits(RenderQuiz, _React$Component);

    function RenderQuiz(props) {
        _classCallCheck(this, RenderQuiz);

        var _this = _possibleConstructorReturn(this, (RenderQuiz.__proto__ || Object.getPrototypeOf(RenderQuiz)).call(this, props));

        _this.handleScreenDataChange = function (data) {
            _this.screenData = _this.screenData.setIn([_this.state.currentScreen.get('id')], data);
        };

        _this.handleLeadDataChange = function (data) {
            var fieldsInfo = _this.leadData.get('fieldsInfo').merge(data.get('fieldsInfo'));
            var values = _this.leadData.get('values').merge(data.get('values'));
            _this.leadData = new _immutable.Map({ fieldsInfo: fieldsInfo, values: values });

            var isLastScreen = _this.state.currentScreen.get('id') === _this.allQsExceptResults.last().get('id');
            if (_this.leadData.get('values').get(_RenderForm.TC_ID) && (isLastScreen || _this.leadData.get('values').get(COMPLETE))) {
                window.isSubmittinglead = true;
                _this.sendLeadData();
            }
        };

        _this.getLeadData = function () {
            var quizType = _this.props.quizData.get('quiz_type') || 'quiz';
            var answers = _this.getAllResults();

            return {
                answers: answers,
                quizType: quizType
            };
        };

        _this.sendLeadData = function () {
            if (_this.props.preview) {
                return;
            }

            var _this$getLeadData = _this.getLeadData(),
                answers = _this$getLeadData.answers,
                quizType = _this$getLeadData.quizType;

            _this.leadSubmitter.submitLead(_this.settings, _this.leadData, _this.quiz_id, _this.published_at, answers, quizType);
        };

        _this.recurseRedirectCheck = function (targetUrl) {
            var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

            if (n > 30) {
                alert('There was an error. Please Try again');
                return false;
            }
            setTimeout(function () {
                if (window.isSubmittinglead) {
                    _this.recurseRedirectCheck(targetUrl, n + 1);
                } else {
                    window.location = targetUrl;
                }
            }, 200);
        };

        _this.nextScreen = function (targetUrl) {
            _this.tracking.trackTiming({
                category: _this.getQuizTrackingPath(),
                variable: 'Time on quiz screen',
                label: _this.getCurrentScreenTrackingPath(_this.state.currentScreen)
            });

            var nextScreen = (0, _wseQuizData.nextQs)(_this.qs, _this.state.currentScreen.get('id'));
            var isNotResultsNext = nextScreen && nextScreen.get('id') === _this.allQsExceptResults.last().get('id');
            var isLinkAndNotSubmitted = targetUrl && !_this.leadData.get('values').get(COMPLETE);
            if (isNotResultsNext || isLinkAndNotSubmitted) {
                var complete = new _immutable.Map({ fieldsInfo: new _immutable.Map(), values: new _immutable.Map() });
                complete = complete.setIn(['fieldsInfo', COMPLETE], new _immutable.Map({ type: 'checkbox', name: 'Quiz complete' }));
                complete = complete.setIn(['values', COMPLETE], true);
                _this.handleLeadDataChange(complete);
            }
            if (targetUrl) {
                if (!!window.isSubmittinglead) {
                    _this.recurseRedirectCheck(targetUrl);
                } else {
                    window.location = targetUrl;
                }
                return;
            }

            if (nextScreen) {
                _this.setState({ currentScreen: nextScreen });
            }
        };

        _webfontloader2.default.load({
            google: {
                families: ['Montserrat']
            },
            loading: function loading() {
                return null;
            },
            active: function active() {
                return null;
            },
            inactive: function inactive() {
                return console.error('Font loading error');
            }
        });

        var quizData = _immutable.Map.isMap(props.quizData) ? props.quizData : (0, _immutable.fromJS)(props.quizData);

        _this._updateQuizData(quizData);
        _this.state = {
            currentScreen: _this._getScreen(props.previewQuizScreen),
            formArgs: props.formArgs || {}
        };
        _this.tracking.trackPageView(_this.getFullTrackingPath(_this.state.currentScreen));

        _this.leadSubmitter = new _LeadSubmitter2.default(_this.props.apiUrl);
        return _this;
    }

    _createClass(RenderQuiz, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var quizData = _immutable.Map.isMap(nextProps.quizData) ? nextProps.quizData : (0, _immutable.fromJS)(nextProps.quizData);
            this._updateQuizData(quizData);
            this.setState({ currentScreen: this._getScreen(nextProps.previewQuizScreen) });
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
            var currentScreenId = this.state.currentScreen && this.state.currentScreen.get('id');
            var nextScreenId = nextState.currentScreen && nextState.currentScreen.get('id');
            if (nextScreenId !== currentScreenId) {
                this.tracking.trackPageView(this.getFullTrackingPath(nextState.currentScreen));
            }
        }
    }, {
        key: '_updateQuizData',
        value: function _updateQuizData(quizData) {
            this.qs = (0, _wseQuizData.orderedQs)(quizData.get('qs'));
            this.settings = quizData.get('settings');
            this.quiz_id = quizData.get('quiz_id');
            this.quiz_name = quizData.get('name');
            this.quiz_type = quizData.get('quiz_type');
            this.published_at = quizData.get('published_at');
            this.questionAndFormQs = (0, _wseQuizData.filterQsByType)(this.qs, ['question', 'form']).toIndexedSeq();
            this.allQsExceptResults = (0, _wseQuizData.filterQsByType)(this.qs, ['intro', 'question', 'text', 'form', 'activity_summary']);

            this.screenData = new _immutable.Map();
            this.leadData = new _immutable.Map({ fieldsInfo: new _immutable.Map(), values: new _immutable.Map() });

            this.tracking = new _Tracking2.default({
                id: this.quiz_id,
                published_at: this.published_at,
                territoryGA: this.settings.getIn(['meta', 'integrations', 'ga']),
                internationalGA: this.settings.getIn(['international_meta', 'integrations', 'ga']),
                previewMode: this.props.preview
            });

            if (this.props.onTracking) this.tracking.addHook(this.props.onTracking);
        }
    }, {
        key: '_getScreen',
        value: function _getScreen(previewQuizScreen) {
            return this.qs && previewQuizScreen && this.qs.get(previewQuizScreen) || this.qs && this.qs.first();
        }
    }, {
        key: 'getResults',
        value: function getResults(question, answers) {
            var questionBlocks = question.getIn(['data', 'question', 'content', 'blocks']);
            var questionText = questionBlocks.size && questionBlocks.get(0).get('text');

            var correctAnswers = question.getIn(['data', 'answers']).filter(function (answer) {
                return answer.get('selected') === 'Correct';
            }).map(function (answer) {
                return { id: answer.get('id'), text: answer.get('text') };
            }).toArray();

            var givenAnswers = answers.map(function (answer) {
                return {
                    id: answer.get('id'),
                    text: answer.get('text'),
                    selected: answer.get('selected')
                };
            }).toArray();

            var correctAnswerIds = correctAnswers.map(function (correctAnswer) {
                return correctAnswer.id;
            });
            var correct = givenAnswers.every(function (answer) {
                return correctAnswerIds.includes(answer.id);
            });
            var values = givenAnswers.map(function (answer) {
                return answer.text;
            }).join(',');
            var level = givenAnswers.map(function (answer) {
                return answer.selected;
            }).join(',');

            return {
                values: values,
                level: level,
                correct: correct,
                questionText: questionText,
                correctAnswers: correctAnswers,
                givenAnswers: givenAnswers
            };
        }
    }, {
        key: 'getAllResults',
        value: function getAllResults() {
            var _this2 = this;

            return this.screenData.mapEntries(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    k = _ref2[0],
                    v = _ref2[1];

                var question = _this2.qs.get(k);
                var answers = v.toSeq();
                return [question.get('id'), _this2.getResults(question, answers)];
            });
        }
    }, {
        key: 'getQuizTrackingPath',
        value: function getQuizTrackingPath() {
            return ['activity-builder', 'territory=' + encodeURIComponent(this.settings.get('name')), 'quiz=' + encodeURIComponent(this.quiz_type) + '-' + encodeURIComponent(this.quiz_name)].join('/');
        }
    }, {
        key: 'getCurrentScreenTrackingPath',
        value: function getCurrentScreenTrackingPath(currentScreen) {
            if (!currentScreen) return '';
            return 'screen=' + this.allQsExceptResults.toIndexedSeq().keyOf(currentScreen) + ' (' + currentScreen.get('type') + ')';
        }
    }, {
        key: 'getFullTrackingPath',
        value: function getFullTrackingPath(currentScreen) {
            return this.getQuizTrackingPath() + '/' + this.getCurrentScreenTrackingPath(currentScreen);
        }
    }, {
        key: 'getExampleResults',
        value: function getExampleResults() {
            var questions = (0, _wseQuizData.filterQsByType)(this.qs, ['question']);
            if (!questions) return [];

            return questions.map(function (block) {
                var questionBlocks = block.getIn(['data', 'question', 'content', 'blocks']);
                var questionText = questionBlocks.get(0) && questionBlocks.get(0).get('text');

                return {
                    isExample: true,
                    questionText: questionText,
                    correctAnswers: [],
                    givenAnswers: [],
                    correct: true
                };
            }).toArray();
        }
    }, {
        key: 'mountScreen',
        value: function mountScreen(measureRef, contentRect) {
            var _this3 = this;

            if (!this.state.currentScreen || !this.state.currentScreen.get('data')) {
                return null;
            }

            var _ref3 = this.props || {},
                quizId = _ref3.quizId;

            var viewWidth = contentRect.client.width;
            var viewHeight = contentRect.client.height;

            var whitelist = true;
            if (!this.props.preview) {
                whitelist = false;
                if (this.settings && this.settings.get('meta')) {
                    var domain_whitelist = ['localhost', '127.0.0.1', 'quiz.wsemktapp.com'];
                    var meta = this.settings.get('meta');
                    if (!!meta && !!meta.get('integrations') && !!meta.get('integrations').get('domain_whitelist')) {
                        domain_whitelist = domain_whitelist.concat(meta.get('integrations').get('domain_whitelist').split('\n'));
                    }
                    if (domain_whitelist.indexOf(window.location.hostname) > -1) {
                        whitelist = true;
                    } else {
                        console.error(window.location.hostname + ' is on NOT the embed whitelist for this WSE territory');
                    }
                }
            }

            if (!viewWidth || !viewWidth) {
                var elements = document.getElementsByClassName('wse-quiz');
                Array.prototype.forEach.call(elements, function (element) {
                    var elementId = !!element.dataset && element.dataset.wseQuizId || false;
                    if (quizId === elementId) {
                        viewHeight = viewHeight || element.offsetHeight;
                        viewWidth = viewWidth || element.offsetWidth;
                    }
                });
            }

            var currentScreenClass = viewWidth >= MOBILE_BREAK_PT ? 'wsequiz wsequiz_large' : 'wsequiz wsequiz_small';
            var isRTL = this.state.currentScreen.get('data') && this.state.currentScreen.get('data').get('isRTL');
            currentScreenClass += ' wsequiz_' + (isRTL ? 'rtl' : 'ltr');

            var props = {
                renderType: this.state.currentScreen.get('type'),
                data: this.state.currentScreen.get('data'),
                position: this.state.currentScreen.get('pos'),
                preview: this.props.preview,
                settings: this.settings,
                quizType: this.props.quizType || this.quiz_type,
                leadData: this.leadData ? (0, _immutable.fromJS)(this.leadData) : null,
                regions: this.settings.get('regions'),
                trackEvent: function trackEvent(opts) {
                    return _this3.tracking.trackEvent(Object.assign({ category: _this3.getQuizTrackingPath() }, opts));
                },
                viewWidth: viewWidth,
                viewHeight: viewHeight,
                handleNext: this.nextScreen,
                previewQuizScreen: this.props.previewQuizScreen,
                progress: this.questionAndFormQs && this.questionAndFormQs.keyOf(this.state.currentScreen),
                onChange: this.handleScreenDataChange,
                className: currentScreenClass,
                measureRef: measureRef,
                whitelist: whitelist
            };

            var extraprops = {
                whitelist: whitelist
            };

            switch (this.state.currentScreen.get('type')) {
                case 'intro':
                    props.className += ' wsequiz_intro';
                    return _react2.default.createElement(_RenderText2.default, _extends({}, props, extraprops));
                case 'question':
                    {
                        props.className += ' wsequiz_question';
                        return _react2.default.createElement(_RenderQuestion2.default, _extends({}, props, extraprops));
                    }
                case 'text':
                    {
                        props.className += ' wsequiz_text';
                        return _react2.default.createElement(_RenderText2.default, _extends({}, props, extraprops));
                    }
                case 'form':
                    {
                        var lastForm = (0, _wseQuizData.filterQsByType)(this.qs, 'form').last();
                        props.className += ' wsequiz_form';
                        if (this.props.formArgs) {
                            props.formArgs = this.props.formArgs;
                        }
                        return _react2.default.createElement(_RenderForm2.default, _extends({}, props, extraprops, {
                            quizId: quizId,
                            onChange: this.handleLeadDataChange,
                            isLast: lastForm.get('id') === this.state.currentScreen.get('id') }));
                    }
                case 'activity_summary':
                    {
                        props.className += ' wsequiz_summary';
                        var results = this.getAllResults().toArray();
                        var exampleResults = this.getExampleResults();

                        var renderSummaryProps = _extends({}, props, {
                            results: results,
                            exampleResults: exampleResults
                        });
                        return _react2.default.createElement(_RenderSummary2.default, _extends({}, renderSummaryProps, extraprops));
                    }
                case 'result_email':
                    {
                        props.className += ' wsequiz_email';
                        var _results = this.getAllResults().toArray();
                        var _exampleResults = this.getExampleResults();

                        var renderEmailProps = _extends({}, props, {
                            results: _results,
                            exampleResults: _exampleResults
                        });

                        if (!this.props.preview) {
                            var _getLeadData = this.getLeadData(),
                                answers = _getLeadData.answers,
                                quizType = _getLeadData.quizType;

                            var transformedLead = this.leadSubmitter._transformLead(this.settings, this.leadData, this.quiz_id, this.published_at, answers, quizType);
                            renderEmailProps.transformedLead = transformedLead;
                        };

                        return _react2.default.createElement(_RenderEmail2.default, _extends({}, renderEmailProps, extraprops));
                    }
                default:
                    return null;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            return _react2.default.createElement(
                _reactCookie.CookiesProvider,
                null,
                _react2.default.createElement(
                    _reactMeasure2.default,
                    { client: true },
                    function (_ref4) {
                        var measureRef = _ref4.measureRef,
                            contentRect = _ref4.contentRect;
                        return _this4.mountScreen(measureRef, contentRect);
                    }
                )
            );
        }
    }]);

    return RenderQuiz;
}(_react2.default.Component);

RenderQuiz.propTypes = {
    preview: _propTypes.PropTypes.bool,
    quizType: _propTypes.PropTypes.string
};
exports.default = RenderQuiz;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wse-quiz-component/lib/RenderQuiz.js
// module id = 337
// module chunks = 0